export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOGGEDIN = "LOGGEDIN";
export const CLEAR_ALL = "CLEAR_ALL";
export const SET_POSTS = "SET_POSTS";
export const SET_SELECTED_USER = "SET_SELECTED_USER";
export const SET_GROUPS = "SET_GROUPS";
export const SET_SELECTED_GROUP = "SET_SELECTED_GROUP";
export const SET_GROUP_POSTS = "SET_GROUP_POSTS";
export const SET_USER_LIST = "SET_USER_LIST";
export const SET_SELECTED_CHAT = "SET_SELECTED_CHAT";
export const SET_MESSAGES = "SET_MESSAGES";
export const SET_USER_LIKES = "SET_USER_LIKES";
